import React from 'react';
import Notifications from '../../../components/notifications/Notifications/Notifications';

const Messages = () => {
    return (
        <>
            <div style={{ background: "linear-gradient(-155deg, #00B2FF -35%, #1E0342 75%)", height: "100vh" }}>
                <main>
                    <Notifications />
                </main>
            </div>
        </>
    );
};

export default Messages;